export default "__VITE_ASSET__BVc9QEi5__"